<template>
    <div class="d-flex flex-row justify-content-between row-item">
      <div v-if="user" class="w-75">        
        <div class="truncate-text text-lighter user-name">{{ user.name }}
        </div>
        <div v-if="user" class="text-uppercase card-text mt-1 text-lighter team-section truncate-text" >
            {{ user.platoon_name || "" }} /
            {{ user.section_name || "" }}
        </div>
      </div>
      <div class="card-text w-18 score">{{ user.score }}</div>
      <div class="d-flex flex-row justify-content-between text-xs card-text text-lighter w-7">
        <router-link
          target="_blank"
          :to="{
            name: `User`,
            params: { udid: user.udid },
            query: { date: getDate()},
          }"
          exact
        >
        <icon-arrow-right class="ml-1 arrow-icon" />
      </router-link>
    </div>
    </div>
  </template>
  
  <script>
  import IconArrowRight from "@/shared/Controls/Icons/IconArrowRight.vue";
  import DateUtils from "@/helpers/dateUtils";
  
  export default {
    components: {
      IconArrowRight,
    },
    props: {
      user: {
        type: Object,
        required: true,
      },
      selectedDate:{
        type: Object,
        required: true,
      }
    },
    methods: {
      getDate() {
       return DateUtils.formatDateToBucketDate(this.selectedDate)
      },
    }
  };
  </script>
  
  <style lang="scss" scoped>
    .row-item {
     align-items: center;
     padding-top: 0.25rem;
     padding-bottom: 0.25rem;
    }
    .user-name{
      font-size: 0.9rem !important;
      color:#fff !important;
    }

    .truncate-text {
      max-width:99% !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .team-section {
      font-size: 0.5rem !important;
      margin-top: 0rem !important;
      font-size: 0.7rem !important;
    }

    .score {
      color: white;
      font-weight: 500;
      text-align: center;
    }

    .tooltip {
      position: relative;
      display: inline-block;
      cursor: default;
    }

    .tooltip .tooltiptext {
      visibility: hidden;
      padding: 0.25em 0.5em;
      background-color: black;
      color: #fff;
      text-align: center;
      border-radius: 0.25em;
      white-space: nowrap;      
      position: absolute;
      z-index: 1;
      top: 100%;
      left: 100%;
      transition-property: visibility;
      transition-delay: 0s;
    }

    .tooltip:hover .tooltiptext {
      visibility: visible;
      transition-delay: 0.3s;
    }
    .arrow-icon {
      height: 1.2rem !important;
    }
  </style>